import {cancel, invoke, on} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterNetworkManage extends BridgeMethod {

  constructor() {
    super();
  }

  async pingCheck(url) {
    return invoke("pingCheck", {params: {'url': url}});
  }

  async checkConnectivity() {
    return invoke("checkConnectivity");
  }

  async getNetworkInfo() {
    return invoke("getNetworkInfo");
  }

  onConnectivityChange(callback) {
    return on("onConnectivityChange", callback, {isSend: true});
  }

  offConnectivityChange(callback) {
    return cancel("onConnectivityChange", {event: callback, isSend: true});
  }
}

export const flutterNetworkManage = new FlutterNetworkManage();